<template>
  <div id="app">
    <nav>
      <router-link to="/">Home</router-link>
      <router-link to="/booking">Book Appointment</router-link>
      <router-link to="/admin">Admin Panel</router-link>
      <router-link to="/login" v-if="!user">Login</router-link>
      <button v-if="user" @click="logout">Logout</button>
    </nav>

    <router-view />

    <footer>
      <p>&copy; 2024 Booking System. All rights reserved.</p>
    </footer>
  </div>
</template>

<script>
import { auth } from "./firebase/firebaseConfig";
import { onAuthStateChanged, signOut } from "firebase/auth";

export default {
  data() {
    return {
      user: null,
    };
  },
  created() {
    // Listen for authentication state changes
    onAuthStateChanged(auth, (user) => {
      this.user = user;
    });
  },
  methods: {
    async logout() {
      await signOut(auth);
      alert("✅ Logged out successfully!");
      this.$router.push("/login");
    },
  },
};
</script>

<style>
/* Global styles */
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  background-color: #f4f4f4;
}
nav {
  background-color: #333;
  padding: 10px;
  display: flex;
  justify-content: space-around;
}
nav a {
  color: white;
  text-decoration: none;
  font-weight: bold;
}
nav a:hover {
  text-decoration: underline;
}
button {
  background-color: #ff4d4d;
  color: white;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 5px;
}
footer {
  text-align: center;
  padding: 20px;
  background-color: #333;
  color: white;
  margin-top: 20px;
}
</style>
